import React, { Context, use, useEffect } from "react";

import { getAuthenticationContext } from "@utils/configuration/aem";

import CallService, { CallServiceKey } from "@services/call.service";
import FeatureToggles, {
    FeatureToggleKeys,
} from "@services/featureToggles.services";

import { useThunkDispatch } from "@redux/dispatcher";
import { load } from "@redux/modules/api/data/customer/customer.module";

type AuthorisationContextValues = {};

type AuthorisationProviderProps = {
    children?: React.ReactNode;
};

const defaultContext: AuthorisationContextValues = {};

const AuthorisationContext: Context<AuthorisationContextValues> =
    React.createContext<AuthorisationContextValues>(defaultContext);

const AuthorisationProvider = ({ children }: AuthorisationProviderProps) => {
    const { authenticationRequired } = getAuthenticationContext();
    const dispatcher = useThunkDispatch();

    useEffect(() => {
        if (
            authenticationRequired ||
            FeatureToggles.isEnabled(FeatureToggleKeys.AUTHORISATION_MODE)
        ) {
            CallService.enable(CallServiceKey.Customer);
            dispatcher(load());
        }
    }, [authenticationRequired]);

    return <AuthorisationContext value={{}}>{children}</AuthorisationContext>;
};

const useAuthorisationContext = (): AuthorisationContextValues => {
    const context =
        use<AuthorisationContextValues>(AuthorisationContext);
    if (context === undefined) {
        throw new Error("No context found");
    }
    return context;
};

export { useAuthorisationContext, AuthorisationProvider };
